module.exports = __webpack_public_path__ + "static/media/mail.d10401cf.svg";